const state = {
  isContentReload:true,
  isRightReload:true,
}

const mutations = {
  CHANGE_CONTENTRELOAD: (state,data) => {
    state.isContentReload = data
  },
  CHANGE_RIGHTRELOAD: (state,data) => {
    state.isRightReload = data
  },
}

const actions = {
  changeContentReload({commit},data) {
    commit('CHANGE_CONTENTRELOAD',data)
  },
   changeRightReload({commit},data) {
    commit('CHANGE_RIGHTRELOAD',data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/reload.js